import { parseApiDate } from "../lib/paymentHold"
import { useEffect, useState } from "react"

type UseTimerResult = {
    remainSec: number | null
    formatted: string | null
    isParsed: boolean
}

export function useTimer(expiredAt?: string, durationSec?: number): UseTimerResult {
    const calcRemain = (): { remain: number | null; parsed: boolean } => {
        if (!expiredAt) return { remain: null, parsed: false }

        const baseTime = parseApiDate(expiredAt)
        if (baseTime == null) return { remain: null, parsed: false }

        const endTime = durationSec != null ? baseTime + durationSec * 1000 : baseTime
        const diff = Math.floor((endTime - Date.now()) / 1000)
        return { remain: diff > 0 ? diff : null, parsed: true }
    }

    const [remainSec, setRemainSec] = useState<number | null>(() => calcRemain().remain)
    const [isParsed, setIsParsed] = useState(() => calcRemain().parsed)

    useEffect(() => {
        if (!expiredAt) {
            setRemainSec(null)
            setIsParsed(false)
            return
        }

        const baseTime = parseApiDate(expiredAt)
        if (baseTime == null) {
            setRemainSec(null)
            setIsParsed(false)
            return
        }

        setIsParsed(true)
        const endTime = durationSec != null ? baseTime + durationSec * 1000 : baseTime

        const update = () => {
            const diff = Math.floor((endTime - Date.now()) / 1000)
            setRemainSec(diff > 0 ? diff : null)
        }

        update()
        const id = setInterval(update, 1000)
        return () => clearInterval(id)
    }, [expiredAt, durationSec])

    const formatted =
        remainSec != null ? `${String(Math.floor(remainSec / 60)).padStart(2, "0")}:${String(remainSec % 60).padStart(2, "0")}` : null

    return { remainSec, formatted, isParsed }
}
